<template>
  <div
    v-if="!isHidden"
    :class="isWebRedesign ? 'info-pac-search-type rhg-rd-m-regular' : 'info-pac-search-type'"
  >
    <div class="info-pac-search-type__body">
      <i class="info-pac-search-type-icon rhg-font-icon--info"></i>
      <div class="info-pac-search-type__message">
        <p class="info-pac-search-type__title">{{ translate('rdRatesDisplayedAreFiltered') }}</p>
        <p class="info-pac-search-type__subtitle">
          {{ translate('rdSeeRestOfRatesAvailable') }}
          <button
            type="button"
            data-testid="info-pac-cta"
            class="info-pac-search-type__cta rhg-btn-link rhg-btn-link--small rhg-btn-link__uppercase rhg-btn-link__bold"
            @click="$emit('clickedCTA')"
          >
            <span class="info-pac-search-type__button-text">
              {{ translate('rdSeeOtherAvailableRates') }}
            </span>
            <i class="rhg-font-icon--arrow-right info-pac-search-type__arrow-cta"></i>
          </button>
        </p>
      </div>
      <div class="info-pac-search-type__close-info">
        <icon @click="isHidden = true" class="rhg-font-icon--close"></icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoPacSearchType',
  data: () => ({
    isHidden: false
  }),
  methods: {
    isWebRedesign() {
      return (
        global.ConfigDynamic?.isEnabled({ key: 'web.redesign.0' }) &&
        global.ConfigDynamic?.isEnabled({ key: 'web.redesign.1' })
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.rhg-rd-m-regular {
  @media (min-width: 992px) {
    margin: 24px 48px !important;
  }
}

.info-pac-search-type {
  display: flex;
  padding: 24px;
  background-color: #dbe3ec;
  max-width: 1440px;
  margin: 0px;
  &__body {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    align-self: start;
    width: 100%;
    justify-content: space-between;
    .info-pac-search-type-icon {
      font-size: 24px;
      margin-inline-end: 8px;
    }
  }
  &__message {
    color: #242424;
    width: 100%;
    margin-inline-end: 8px;
    text-align: start;
  }
  &__title {
    font-size: 16px;
    font-weight: 700;
    margin: 0px;
    line-height: 20px;
  }
  &__subtitle {
    line-height: 20px;
    font-size: 16px;
    margin: 0px;
    gap: 0px 6px;
    flex-wrap: wrap;
    display: flex;
  }
  &__cta {
    display: inline-block;
    padding-inline-end: 6px;
    padding-inline-start: 0px;
    text-align: start;
    &:hover {
      .info-pac-search-type__button-text {
        text-decoration: underline;
      }
      .info-pac-search-type__arrow-cta {
        color: #9e0918;
      }
    }
  }
  &__arrow-cta {
    display: inline-block;
    font-size: 22px;
    width: 22px;
    height: 22px;
    position: relative;
    top: -2px;
  }
  &__button-text {
    line-height: 20px;
    font-size: 16px;
  }
  &__close-info {
    cursor: pointer;
  }
}
@media (min-width: 992px) {
  .info-pac-search-type {
    padding: 16px 48px 16px 48px;
    &__subtitle,
    &__title {
      line-height: 22px;
    }
    &__body {
      align-items: center;
    }
  }
}
</style>
